import React, { useEffect, useRef } from "react";

export default function ConfirmDialog({
  title = "Confirm",
  message,
  confirmText = "OK",
  cancelText = "Cancel",
  onConfirm,
  onCancel,
}) {
  const confirmRef = useRef(null);

  useEffect(() => {
    confirmRef.current?.focus?.();
  }, []);

  useEffect(() => {
    function onKeyDown(e) {
      if (e.key === "Escape") onCancel?.();
      if (e.key === "Enter") onConfirm?.();
    }
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [onCancel, onConfirm]);

  return (
    <section
      className="mac-window mac-dialog"
      role="dialog"
      aria-label={title}
      aria-modal="true"
    >
      <div className="mac-windowTitleBar">
        <button
          type="button"
          className="mac-windowClose"
          onClick={onCancel}
          aria-label="Close dialog"
          title="Close"
        >
          ×
        </button>
        <div className="mac-windowTitle" title={title}>
          {title}
        </div>
        <div className="mac-windowSpacer" aria-hidden="true" />
      </div>

      <div className="mac-windowBody mac-dialogBody">
        <div className="mac-dialogMessage">{message}</div>
        <div className="mac-dialogActions">
          <button type="button" className="mac-button" onClick={onCancel}>
            {cancelText}
          </button>
          <button
            ref={confirmRef}
            type="button"
            className="mac-button mac-buttonDanger"
            onClick={onConfirm}
          >
            {confirmText}
          </button>
        </div>
      </div>
    </section>
  );
}

